import { atom } from 'recoil'

export const modalSendingSegmentationState = atom({
  key: 'emailSendingWizardModalSendingSegmentationState',
  default: {
    show: false,
    loading: false,
    error: undefined,
    severity: undefined,
    queued: undefined,
    groups: [],
    excludedGroups: [],
    filters: [],
    section: 'groups',
    idMessage: undefined,
    idSending: undefined,
    simulationEnabled: false,
    simulationLoading: false,
    simulationLoaded: false,
    simulationResult: undefined,
    simulationDiff: undefined
  }
})

export const modalSaveDefaultState = atom({
  key: 'emailSendingWizardModalSaveDefault',
  default: {
    show: false,
    loading: false,
    error: undefined,
    severity: undefined,
    success: false
  }
})

export const modalFilterDetailState = atom({
  key: 'emailSendingWizardModalFilterDetails',
  default: {
    show: false
  }
})

export const modalColumnsManagementState = atom({
  key: 'emailSendingWizardModalColumnsManagementsState',
  default: {
    show: false
  }
})

export const modalDeleteState = atom({
  key: 'emailSendingWizardModalDeleteState',
  default: {
    show: false
  }
})

export const modalResetSendState = atom({
  key: 'emailSendingWizardModalResetSendSatte',
  default: {
    show: false
  }
})

export const modalSchedulingState = atom({
  key: 'EmailSendingWizardModalScheduleSendingState',
  default: {
    show: false,
    idSending: undefined,
    idList: undefined,
    startDate: undefined,
    timeZoneCode: undefined,
    countImmediate: undefined,
    error: undefined,
    severity: undefined
  }
})
